const riot = require('riot');

riot.tag2('popup-note-filter', '<div class="w128 bg-white py8 px12 rounded-8 box-shadow-primary" ref="popup"> <label class="f fm cursor-pointer mb4 mb0-last" each="{item in app.data.note.filter}"> <input class="checkbox" type="checkbox"> <div class="fs10 lh15 mln2">{item.label}</div> </label> </div>', '', '', function(opts) {
});